// src/pages/HomePage.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getPersons, getStats } from '../services/api';

const STATUS_CFG = {
  URGENTE:      { bg: '#FF2D2D', label: 'URGENTE' },
  DESAPARECIDA: { bg: '#FF8C00', label: 'DESAPARECIDO/A' },
  ENCONTRADA:   { bg: '#00C853', label: 'ENCONTRADA' },
};

const Badge = ({ status, gender }) => {
  const isMasc = gender === 'Masculino'; const cfg = STATUS_CFG[status] ? { ...STATUS_CFG[status], label: status === 'DESAPARECIDA' ? (isMasc ? 'DESAPARECIDO' : 'DESAPARECIDA') : status === 'ENCONTRADA' ? (isMasc ? 'ENCONTRADO' : 'ENCONTRADA') : STATUS_CFG[status].label } : STATUS_CFG.DESAPARECIDA;
  return (
    <span style={{ display:'inline-block', padding:'2px 9px', borderRadius:6, fontSize:10, fontWeight:800, letterSpacing:.8, background:cfg.bg+'28', color:cfg.bg, border:`1px solid ${cfg.bg}55` }}>
      {cfg.label}
    </span>
  );
};

const formatTime = (days) => {
  if (days < 30) return `${days}d`;
  if (days < 365) {
    const m = Math.floor(days / 30);
    const d = days % 30;
    return d > 0 ? `${m}m ${d}d` : `${m}m`;
  }
  const y = Math.floor(days / 365);
  const m = Math.floor((days % 365) / 30);
  return m > 0 ? `${y}a ${m}m` : `${y}a`;
};

const PersonCard = ({ p }) => (
  <Link to={`/caso/${p.id}`} style={{ textDecoration: 'none' }}>
    <div style={{ background:'rgba(255,255,255,0.035)', borderRadius:16, border: p.status==='URGENTE' ? '1px solid rgba(255,45,45,0.4)' : '1px solid rgba(255,255,255,0.07)', overflow:'hidden', transition:'transform .25s, box-shadow .25s', cursor:'pointer' }}
      onMouseEnter={e => { e.currentTarget.style.transform='translateY(-4px)'; e.currentTarget.style.boxShadow = p.status==='URGENTE' ? '0 16px 48px rgba(255,45,45,.25)' : '0 16px 40px rgba(0,0,0,.5)'; }}
      onMouseLeave={e => { e.currentTarget.style.transform='none'; e.currentTarget.style.boxShadow='none'; }}
    >
      <div style={{ position:'relative', height:210, background:'#111' }}>
        {p.photoUrl
          ? <img src={p.photoUrl} alt={p.name} style={{ width:'100%', height:'100%', objectFit:'cover' }} onError={e => { e.target.style.display='none'; }} />
          : <div style={{ width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:48, fontWeight:800, color:'#7B93D4' }}>{p.name.split(' ').slice(0,2).map(n=>n[0]).join('')}</div>
        }
        <div style={{ position:'absolute', inset:0, background:'linear-gradient(to bottom, transparent 45%, rgba(8,8,12,.85))' }} />

        {p.status === 'URGENTE' && (
          <div style={{ position:'absolute', top:10, left:10, display:'flex', alignItems:'center', gap:5, background:'rgba(255,45,45,0.92)', borderRadius:8, padding:'3px 9px' }}>
            <span style={{ width:6, height:6, borderRadius:'50%', background:'#fff', display:'inline-block' }} />
            <span style={{ fontSize:9, fontWeight:800, color:'#fff', letterSpacing:.8 }}>URGENTE</span>
          </div>
        )}

        {p.daysActive > 0 && (
          <div style={{ position:'absolute', bottom:8, right:8, background:'rgba(0,0,0,.75)', borderRadius:6, padding:'2px 8px', fontSize:10, color:'#FF6B6B', fontWeight:700 }}>
            {formatTime(p.daysActive)} desaparecido/a
          </div>
        )}

        {p.status === 'ENCONTRADA' && (
          <div style={{ position:'absolute', inset:0, background:'rgba(0,200,83,0.15)', display:'flex', alignItems:'center', justifyContent:'center' }}>
            <span style={{ fontSize:36 }}>&#9989;</span>
          </div>
        )}
      </div>

      <div style={{ padding:'12px 14px 15px' }}>
        <Badge status={p.status} gender={p.gender} />
        <div style={{ fontSize:14, fontWeight:700, color:'#F0EDE8', margin:'6px 0 3px', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{p.name}</div>
        <div style={{ fontSize:12, color:'#777' }}>{p.age} a&ntilde;os &middot; {p.location}</div>
        <div style={{ fontSize:11, color:'#555', marginTop:4 }}>Visto por &uacute;ltima vez: {p.lastSeen}</div>
      </div>
    </div>
  </Link>
);

export default function HomePage() {
  const [urgent,  setUrgent]  = useState([]);
  const [recent,  setRecent]  = useState([]);
  const [stats,   setStats]   = useState({ activos: 0, esteMes: 0, encontrados: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      getPersons('?status=URGENTE&limit=6'),
      getPersons('?limit=12'),
      getStats(),
    ]).then(([urg, rec, st]) => {
      setUrgent(urg.persons || []);
      setRecent((rec.persons || []).filter(p => p.status !== 'URGENTE'));
      if (st) setStats(st);
    }).catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      {/* Hero */}
      <div style={{ background:'linear-gradient(135deg,#0A0A0F 0%,#1A0A2E 50%,#0A0A0F 100%)', padding:'60px 24px 60px', borderBottom:'1px solid rgba(255,45,45,0.12)', position:'relative', overflow:'hidden' }}>
        <div style={{ position:'absolute', inset:0, background:'radial-gradient(ellipse at 50% 0%, rgba(255,45,45,0.1) 0%, transparent 65%)' }} />
        <div className="hero-inner" style={{ position:'relative', maxWidth:1100, margin:'0 auto', display:'flex', alignItems:'center', gap:40, justifyContent:'center' }}>

          {/* Video 9:16 */}
          <div className="hero-video" style={{ flexShrink:0, width:260 }}>
            <div style={{ position:'relative', paddingBottom:'177.78%', borderRadius:18, overflow:'hidden', boxShadow:'0 8px 40px rgba(255,45,45,0.25), 0 0 0 1px rgba(255,45,45,0.2)' }}>
              <iframe
                src="https://www.youtube.com/embed/_i978VZBCUU?autoplay=0&rel=0"
                title="VuelveACasa RD"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{ position:'absolute', top:0, left:0, width:'100%', height:'100%', border:'none' }}
              />
            </div>
          </div>

          {/* Hero text */}
          <div className="hero-text" style={{ flex:1, textAlign:'center', maxWidth:600 }}>
            <div style={{ display:'inline-flex', alignItems:'center', gap:7, background:'rgba(255,45,45,0.1)', border:'1px solid rgba(255,45,45,0.28)', borderRadius:20, padding:'5px 16px', marginBottom:28, fontSize:11, fontWeight:800, color:'#FF6B6B', letterSpacing:1 }}>
              <span style={{ width:6, height:6, borderRadius:'50%', background:'#FF2D2D', display:'inline-block' }} />
              &#127465;&#127476; RED NACIONAL DE B&Uacute;SQUEDA &mdash; REP&Uacute;BLICA DOMINICANA
            </div>

            <h1 style={{ fontSize:'clamp(28px,4.5vw,56px)', fontWeight:900, lineHeight:1.08, marginBottom:22, letterSpacing:'-1.5px', color:'#F0EDE8' }}>
              Cada segundo cuenta.<br />
              <span style={{ color:'#FF8C00' }}>Ay&uacute;danos a encontrarlos.</span>
            </h1>

            <p style={{ fontSize:16, color:'#777', lineHeight:1.75, maxWidth:480, margin:'0 auto 36px' }}>
              Plataforma colaborativa para la localizaci&oacute;n de personas desaparecidas en la Rep&uacute;blica Dominicana. Reporta, comparte y marca la diferencia.
            </p>

            <div style={{ display:'flex', gap:12, justifyContent:'center', flexWrap:'wrap' }}>
              <Link to="/casos">
                <button style={{ background:'#FF2D2D', color:'#fff', border:'none', borderRadius:12, padding:'14px 30px', fontSize:15, fontWeight:700, cursor:'pointer', boxShadow:'0 4px 24px rgba(255,45,45,.35)' }}>
                  Ver todos los casos &#8594;
                </button>
              </Link>
              <Link to="/reportar">
                <button style={{ background:'rgba(255,255,255,0.05)', color:'#ddd', border:'1px solid rgba(255,255,255,0.13)', borderRadius:12, padding:'14px 30px', fontSize:15, fontWeight:600, cursor:'pointer' }}>
                  Reportar desaparici&oacute;n
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Stats + Contador de visitas */}
      <div style={{ background:'rgba(255,45,45,0.04)', borderBottom:'1px solid rgba(255,45,45,0.1)', padding:'22px 24px' }}>
        <div style={{ maxWidth:900, margin:'0 auto', display:'flex', gap:12, flexWrap:'wrap', justifyContent:'center', alignItems:'stretch' }}>
          {[
            { n: stats.activos,     l: 'Casos activos',       c: '#FF2D2D' },
            { n: stats.esteMes,     l: 'Reportados este mes', c: '#FF8C00' },
            { n: stats.encontrados, l: 'Personas encontradas', c: '#00C853' },
          ].map(s => (
            <div key={s.l} style={{ textAlign:'center', padding:'14px 36px', background:'rgba(255,255,255,0.03)', borderRadius:12, border:'1px solid rgba(255,255,255,0.07)', flex:'1 1 160px' }}>
              <div style={{ fontSize:38, fontWeight:900, color:s.c, lineHeight:1 }}>{s.n.toLocaleString()}</div>
              <div style={{ fontSize:11, color:'#666', marginTop:5, letterSpacing:1, textTransform:'uppercase' }}>{s.l}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Listado */}
      <div style={{ maxWidth:1200, margin:'0 auto', padding:'52px 24px 64px' }}>

        <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:22 }}>
          <span style={{ width:8, height:8, borderRadius:'50%', background:'#FF2D2D', display:'inline-block' }} />
          <h2 style={{ fontSize:13, fontWeight:800, color:'#777', letterSpacing:2, textTransform:'uppercase', margin:0 }}>Casos urgentes</h2>
          <Link to="/casos?filter=URGENTE" style={{ marginLeft:'auto', fontSize:13, color:'#FF8C00', fontWeight:600, textDecoration:'none' }}>Ver todos &#8594;</Link>
        </div>

        {loading ? (
          <div style={{ textAlign:'center', padding:60, color:'#444', fontSize:14 }}>Cargando casos...</div>
        ) : (
          <>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(195px, 1fr))', gap:16, marginBottom:52 }}>
              {urgent.slice(0,6).map(p => <PersonCard key={p.id} p={p} />)}
            </div>

            <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:22 }}>
              <h2 style={{ fontSize:13, fontWeight:800, color:'#777', letterSpacing:2, textTransform:'uppercase', margin:0 }}>Casos recientes</h2>
              <Link to="/casos" style={{ marginLeft:'auto', fontSize:13, color:'#FF8C00', fontWeight:600, textDecoration:'none' }}>Ver todos &#8594;</Link>
            </div>

            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(195px, 1fr))', gap:16 }}>
              {recent.slice(0,6).map(p => <PersonCard key={p.id} p={p} />)}
            </div>
          </>
        )}

        <div style={{ marginTop:56, padding:'20px 28px', background:'rgba(255,140,0,0.06)', border:'1px solid rgba(255,140,0,0.2)', borderRadius:14, textAlign:'center' }}>
          <p style={{ margin:0, color:'#888', fontSize:14, lineHeight:1.7 }}>
            &#128680; Si tienes informaci&oacute;n sobre alg&uacute;n caso, llama al <strong style={{ color:'#FF8C00' }}>9-1-1</strong> o usa el bot&oacute;n "Enviar pista" en cada caso.
            <br />La informaci&oacute;n que compartas puede salvar una vida.
          </p>
        </div>
      </div>
    </div>
  );
}
